import script from "./favorites.vue?vue&type=script&setup=true&lang=ts"
export * from "./favorites.vue?vue&type=script&setup=true&lang=ts"

import "./favorites.vue?vue&type=style&index=0&id=148f0919&lang=scss"

const __exports__ = script;

export default __exports__